import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';

const rootSelector = createFeatureSelector('clientVerification');

export const getIsClientVerificationPending = createSelector(
  rootSelector,
  (state) => state?.status === 'pending',
);
